import { scriptHook } from '@convincely/utils/lib/services/inject/script.js';
import { addHook } from '@convincely/utils/lib/services/convincely.js';
import { injectStyle } from '@convincely/utils/lib/services/inject/style.js';
export const init = addHook('init', (opts = {}) => {
    const { scripts = [], styles = [] } = opts;
    for (const url of styles) {
        injectStyle(url);
    }
    for (const url of scripts) {
        injectScript(url);
    }
});
export function injectScript(path) {
    const script = document.createElement('script');
    script.async = true;
    script.type = 'module';
    script.src = path;
    return document.head.appendChild(scriptHook.resolve(script));
}
//# sourceMappingURL=bootstrap.js.map